import { AsyncAjaxPost } from "../../Common/AsyncAjaxService";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";


export  async function UploadImage(userContext:UserContext,filename:string,Base64:string,successCallback:Function=()=>{},failCallback:Function=()=>{},completeCallback:Function = ()=>{},folderName:string = "Websitebuilder/"){

  if(userContext.isAdmin){
    folderName=`WB/${userContext.layoutId}/`
  }

    const requestBody = UploadImageReq(
        filename,
        Base64,
        folderName
      );

      await UploadFile(userContext,requestBody,successCallback,failCallback,completeCallback);

}


const readFile = (file:any, onLoadCallback:(file:any)=>void) => {

  var reader = new FileReader();
  reader.onload = onLoadCallback;
  reader.readAsDataURL(file);
};
const imageSize = (filename:string, callback:(size:{width:number,height:number})=>void) => {

  var img = new Image();
  img.onload = function () {
      var myResult = {
          width: img.width,
          height: img.height,
      };
      callback(myResult);
  };
  img.src = filename;
  img.onerror = function () {
      var myResult = {
          width: -101,
          height: -101,
      };
      callback(myResult);
  };
};


export async function ValidateImageDimensions(filesDetails:any,maxWidth:number,maxHeight:number,successCallback:()=>void,failCallback:(message:string)=>void){
  readFile(filesDetails, (e)=> {
    imageSize(e.target.result, (res:any)=>{
   
      if(res.width > maxWidth || res.height > maxHeight){
        failCallback("Image size should be less than "+maxWidth+"x"+maxHeight);
      }else{
        successCallback();
      }
     }
  
  )});
  
  
}

export async function UploadFile(userContext:UserContext,requestBody:any,successCallback:Function=()=>{},failCallback:Function=()=>{},completeCallback:Function = ()=>{}){
   
  const url = userContext.isAdmin ? "layoutpagefile/uploadlibraryimage" :  userContext.businessId+"/websitebuilders/uploadsavegeneralsettingimage";




  await AsyncAjaxPost(
    url,
    requestBody,
    userContext.accessToken,
    function onSuccess(data:any) {
 
      try {
  
        if (data != null && data.data != null && data.data.data != null) {
            
            successCallback(data.data.data);
            completeCallback();
            
        }
       
      } catch (error) {
       
        failCallback(error);
        completeCallback();
      }
    },
    function OnError() {
   
        failCallback("Oops! Something went wrong. Please try again later.");
        completeCallback();
    }
  );
  
}

export async function DeleteFile(userContext:UserContext,filename:string,successCallback:Function=()=>{},failCallback:Function=()=>{},completeCallback:Function=()=>{}) {
  


    const Requestdata:any = {};
    Requestdata.FileName = filename;
    Requestdata.Foldername = "Websitebuilder";

    await AsyncAjaxPost(
        userContext.businessId + "/websitebuilders/deleteuploadfile",
        Requestdata,
        userContext.accessToken,
        function onSuccess(data:any) {
          try {
            if (data !== null && data.data !== null && data.data.data !== null && data.data.data === true) {
                successCallback(data.data.data);
                completeCallback();
            }
         
          } catch (error) {
            failCallback(error);
            completeCallback();
          }
        },
        function OnError() {
            failCallback("Oops! Something went wrong. Please try again later.");
            completeCallback();
        }
      );

}

const UploadImageReq = (
    filename:string,
    Base64:string,
    folderName:string = "Websitebuilder/"
  ) => {
    const Requestdata:any = {};
    Requestdata.FileName = filename;
    Requestdata.base64image = "url(\"data:image/png;base64," + Base64 + "\")";
    Requestdata.Foldername = folderName;

    return Requestdata;
  };